const locale = {
  dashboard: 'Painel de bordo',
  home_dashboard: 'Home',
  dashboard_news: 'Actualidades',
  dashboard_slides: 'Banners',
  dashboard_notifications: 'Notificações ',
  dashboard_account: 'A minha conta',
  dashboard_team: 'A minha equipa',
  dashboard_mini_site: 'Mini-site',
  dashboard_loyalty_campaign: 'Campanhas de fidelização',
  product_order: 'encomenda de produtos',
  digital_pub: 'Publicidade digital',
  training: 'Formação',
  dashboard_content_library: 'Biblioteca de conteúdos',
  hairdressers_network: 'Redes de salão',
  hairdressers: 'Cabeleireiros',
  hairdressers_list: 'Lista de cabeleireiros',
  hairdresser_add: 'Adicionar um salão',
  link_hairdresser_supervisor: 'salão/supervisor de ligação',
  services: 'Serviços',
  services_list: 'Lista dos serviços',
  services_add: 'Adicionar um serviço',
  services_link: 'Associar um serviço',
  national_operations: 'Op. nacionais',
  national_operations_list: 'Lista das op. nacionais',
  national_operations_add: 'Adicionar uma op. nacional',
  national_operations_participate: 'Associar uma op. nacional',
  prices: 'Serviços & preços',
  jobs: 'Ofertas de emprego',
  jobs_list: 'Lista de ofertas de emprego',
  jobs_add: 'Adicionar uma oferta de emprego',
  customer_relationship: 'Relação cliente',
  contacts: 'Contactos',
  contacts_list: 'Lista de contactos',
  contacts_import: 'Importar os contactos',
  origin_code_list: 'Lista dos códigos de origem',
  origin_code_add: 'Adicionar um código de origem',
  feedbacks: 'feedback dos clientes',
  feedbacks_list: 'Lista de feedback dos clientes',
  feedbacks_response_model: 'Modelo de resposta',
  feedbacks_receiver: 'Destinatários de feedback',
  access: 'Acesso',
  collaborators: 'Lista de colaboradores',
  collaborators_add: 'Adicionar um colaborador',
  users_and_groups: 'Utilisadores e grupos',
  users_list: 'Lista dos utilisadores',
  users_add: 'Adicionar um utilisador',
  groups_list: 'Lista dos grupos',
  groups_add: 'Adicionar um grupo',
  resources: 'Recursos',
  press: 'Sala de imprensa',
  press_admin: 'Administração da Imprensa',
  documentation: 'Documentação',
  documentation_admin: 'administração da documentação',
  intranet_doc: 'Espaço documental',
  intranet_doc_admin: 'Documentos de administração v2',
  intranet_doc_v2: 'Documentos v2',
  mass_administration: 'Gestão de massas',
  minisite: 'Minisites',
  minisiteList: 'Acompanhamento de actualizações',
  minisiteMessageList: ' Lista de mensagens ',
  minisiteTagList: 'Lista de meta tags',
  minisiteMassiveImport: 'Administração em massa',
  access_to: 'Acesso a',
  payment_x3: 'Pagamento em 3x',
  prices_list: 'Lista de serviços e tarifas',
  legals_list: 'Lista de avisos legais',
  legals_add: 'Adicionar aviso legal',
  legals_participate: 'Associar aviso legal',
  mass_administration_price_list: 'Serviços e Preços',
  mass_administration_businessHours_list: 'Horário de funcionamento',
  mass_administration_message_list: 'Mensagens de Boas-Vindas',
  mass_administration_tag_list: 'Tags Meta',
  mass_administration_picture_list: 'Fotos',
  terms_nav: 'Termos e Condições',
  TOU: 'Termos de Uso',
  privacy_policy: 'Política de Privacidade',
  cookies_policy: 'Política de gestão de cookies',
  faq: 'Perguntas Mais Frequentes'
};

export default locale;
